export enum FacilityCategoriesTypes {
  TRANSPORTATION = 200,
  ENTERTAINMENT = 203,
  INTERNET = 204,
  PARKING = 205,
  POOL = 206,
  BEACH = 207,
  OUTDOORS = 208,
  GUEST_SERVICES = 209,
  CONVENIENCES = 210,
  ACCESSIBILITY = 211,
  FAMILY_FRIENDLY = 212,
  INCLUSIVITY = 213,
  DINING = 214,
  FOOD_AND_DRINK = 215,
  BUSINESS_SERVICES = 216,
  THINGS_TO_DO = 217,
  WELLNESS = 218,
  SPA = 219,
  OTHERS = 220,
  SAFETY = 221,
  PAYMENT = 222,
  CERTIFICATIONS = 223,
}

export const CATEGORY_FEATURED = null

export type FacilityCategories = FacilityCategoriesTypes | typeof CATEGORY_FEATURED
